module.exports = __webpack_public_path__ + "static/media/pn-pc-teal.2a34793f.svg";